// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-2-portable-power-station_productcontent__cyq_h"};